module.exports = __webpack_public_path__ + "media/img/carq_and_yanosik-479e0b3a.png";